export default class Language {
    constructor() {

    }

    preValidateFormFields(id) {
        let translation = '';

        switch (id) {
            case 'gender':
            case 'geslacht':
            case 'state':
                translation = '%s no ha sido elegido';
                break;

            case 'firstname':
            case 'lastname':
            case 'voorletter':
            case 'achternaam':
                translation = '%s no puede estar vacío';
                break;

            case 'street':
            case 'housenumber':
            case 'city':
            case 'address':
            case 'straat':
            case 'huisnummer':
            case 'plaats':
                translation = '%s es un campo obligatorio';
                break;

            case 'telephone':
            case 'email':
            case 'heeltelefoonnummer':
            case 'mobile':
            case 'zipcode':
            case 'birthdate':
            case 'bankaccount':
                translation = '%s no ha sido cumplimentado correctamente';
                break;

            case 'opt-in':
                translation = 'Por favor selecciona la casilla para continuar';
                break;

            default:
                translation = 'El campo no ha sido cumplimentado correctamente';
                break;
        }

        return translation;
    }
}
